import { combineReducers } from 'redux';
import inventory from './inventory.js'; // Real time inventory
import referenceInventory from './referenceInventory.js'; // This is used as base image with which delta is calculated
export default combineReducers({ inventory, referenceInventory });
